import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  FormGroup,
  Card,
  CardBody,
  Label,
} from "reactstrap";

import { AvForm, AvField } from "availity-reactstrap-validation-safe";
import Select from "react-select";

import Breadcrumbs from "../../../../components/Common/Breadcrumb";
import { SalvarVoltarButtons } from "../../../../components/ActionButton";
import api from "../../../../services/api";

import { useAguarde, useMessageBox } from "../../../../contexts/globalContext";

const EmpresaAtendimentoIncluirPage = (props) => {
  const { setAguarde } = useAguarde();
  const { setMessageBox } = useMessageBox();

  const history = useHistory();

  const [tiposAtendimentos, setTiposAtendimentos] = useState([]);
  const [tipoAtendimentoSelecionado, setTipoAtendimentoSelecionado] = useState(
    []
  );

  const optionTipoAtendimento = [
    {
      options: tiposAtendimentos,
    },
  ];

  const handleSubmit = useCallback(
    async (event, values) => {
      setAguarde(true);
      try {
        if (tipoAtendimentoSelecionado.value) {
          setAguarde(true);
          const response = await api.post(
            `/web/horarioatendimentoempresa/padrao`,
            {
              tipoAtendimentoId: tipoAtendimentoSelecionado.value,
              descricao: values.horario,
            }
          );
          setAguarde(false);

          if (!response.data.success) {
            throw response.data;
          }

          history.push("/cadastros/empresa/atendimento/listar");
        }
      } catch (err) {
        setAguarde(false);
        await setMessageBox({
          show: true,
          title: "Erro",
          description: err.message,
          error: true,
        });
      }
    },
    [history, setAguarde, setMessageBox, tipoAtendimentoSelecionado.value]
  );

  useEffect(() => {
    async function getTipoAtendimento() {
      try {
        const response = await api.get("/web/tipoatendimento");

        if (!response.data.success) {
          throw response.data;
        }

        const listaTipoAtendimento = response.data.data.map(
          (tipoAtendimento) => {
            return {
              label: tipoAtendimento.descricao,
              value: tipoAtendimento.tipoAtendimentoId,
            };
          }
        );

        setTiposAtendimentos(listaTipoAtendimento);
      } catch (err) {
        setTiposAtendimentos([]);
        setAguarde(false);
        await setMessageBox({
          show: true,
          title: "Erro",
          description: err.message,
          error: true,
        });
      }
    }
    getTipoAtendimento();
  }, [setAguarde, setMessageBox]);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumbs
            title="Horários de Atendimento - Inclusão"
            breadcrumbItem="Horário de Atendimento"
          />

          <Row>
            <Col xs="12">
              <Card>
                <CardBody>
                  <AvForm
                    className="form-horizontal"
                    onValidSubmit={(e, v) => {
                      handleSubmit(e, v);
                    }}
                  >
                    <Row>
                      <Col sm="4">
                        <FormGroup>
                          <Label>Tipo de Atendimento</Label>
                          <Select
                            placeholder="Selecione um tipo de atendimento"
                            value={tipoAtendimentoSelecionado}
                            onChange={setTipoAtendimentoSelecionado}
                            options={optionTipoAtendimento}
                            classNamePrefix="select2-selection"
                          />
                        </FormGroup>
                      </Col>
                      <Col sm="8">
                        <FormGroup>
                          <AvField
                            name="horario"
                            label="Horário"
                            className="form-control"
                            placeholder=""
                            type="text"
                            required
                            autoFocus={true}
                            autoComplete="off"
                            errorMessage="Horário não informado"
                          />
                        </FormGroup>
                      </Col>
                    </Row>

                    <SalvarVoltarButtons
                      goBack={() => {
                        history.goBack();
                      }}
                    />
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default EmpresaAtendimentoIncluirPage;
